import { createFileRoute } from '@tanstack/react-router';
import { FundingTypeStepForm } from './-components/project-new-steps/funding-type-step';

export const Route = createFileRoute('/ngos/projects/new/funding-type')({
	component: FundingTypeStepForm,
});
